export default "<style>\n  ul {\n    margin: 0;\n    padding: 0;\n  }\n</style>\n<ul>\n  <slot></slot>\n</ul>\n";